export default "__VITE_ASSET__JoqKParp__"